var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 0.666748H2.66536C1.93203 0.666748 1.33203 1.26675 1.33203 2.00008V11.3334H2.66536V2.00008H10.6654V0.666748ZM12.6654 3.33341H5.33203C4.5987 3.33341 3.9987 3.93341 3.9987 4.66675V14.0001C3.9987 14.7334 4.5987 15.3334 5.33203 15.3334H12.6654C13.3987 15.3334 13.9987 14.7334 13.9987 14.0001V4.66675C13.9987 3.93341 13.3987 3.33341 12.6654 3.33341ZM12.6654 14.0001H5.33203V4.66675H12.6654V14.0001Z",
    fill: "#5A6375"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.987b8d183585a333d342574473e95c29.svg";
export { ForwardRef as ReactComponent };